import { render, staticRenderFns } from "./recover.vue?vue&type=template&id=5b864713&scoped=true&"
import script from "./recover.vue?vue&type=script&lang=js&"
export * from "./recover.vue?vue&type=script&lang=js&"
import style0 from "./recover.vue?vue&type=style&index=0&id=5b864713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b864713",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b864713')) {
      api.createRecord('5b864713', component.options)
    } else {
      api.reload('5b864713', component.options)
    }
    module.hot.accept("./recover.vue?vue&type=template&id=5b864713&scoped=true&", function () {
      api.rerender('5b864713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/userFeedback/components/recover.vue"
export default component.exports